<template>
  <el-tabs stretch id="stockCardtabs" class="content-section">
    <el-tab-pane :label="$t('stock.gainList')">
      <el-table
        :data="gainsData"
        size="mini"
        height="790px"
        :header-cell-style="{ fontSize: '13px', color: '#000000', border: 'none' }"
        :cell-style="{ border: 'none' }"
      >
        <el-table-column min-width="70px" prop="name" :label="$t('stock.name')">
          <template slot-scope="scope">
            <router-link
              :to="{
                name: 'Stockdetailed',
                query: { symbol: scope.row.symbol },
              }"
              class="stockLinkColor"
            >
              <span style="font-size: 13px">{{ scope.row.name }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          min-width="80px"
          prop="trade"
          :label="$t('stock.price')"
          align="center"
        >
          <template slot-scope="scope">
            <span style="color: var(--baseColor)">{{ scope.row.trade }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="70px"
          prop="changepercent"
          :label="$t('stock.qouteChange')"
          align="right"
        >
          <template slot-scope="scope">
            <!--            <span class="green" v-if="scope.row.changepercent.substr(0,1) === '-'">{{ scope.row.changepercent }}%</span>-->
            <!--            <span class="red" v-else>{{ scope.row.changepercent }}%</span>-->
            <span class="red">{{ scope.row.changepercent }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane :label="$t('stock.recent')">
      <el-table
        :data="tableData"
        size="mini"
        height="790px"
        :header-cell-style="{ fontSize: '13px', border: 'none', color: '#000000' }"
        :cell-style="{ border: 'none' }"
      >
        <el-table-column min-width="70px" prop="symbolName" :label="$t('stock.name')">
          <template slot-scope="scope">
            <router-link
              :to="{
                name: 'Stockdetailed',
                query: { symbol: scope.row.symbol },
              }"
              class="stockLinkColor"
            >
              <span style="font-size: 13px">{{ scope.row.symbolName }}</span>
            </router-link>
          </template>
        </el-table-column>
        <el-table-column
          min-width="80px"
          prop="trade"
          :label="$t('stock.price')"
          align="center"
        >
          <template slot-scope="scope">
            <span style="color: var(--baseColor)">{{ scope.row.trade }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="70px"
          prop="changepercent"
          :label="$t('stock.qouteChange')"
          align="right"
        >
          <template slot-scope="scope">
            <span
              class="green"
              v-if="scope.row.changepercent.substr(0, 1) === '-'"
              >{{ scope.row.changepercent }}%</span
            >
            <span class="red" v-else>{{ scope.row.changepercent }}%</span>
          </template>
        </el-table-column>
      </el-table>
    </el-tab-pane>
    <el-tab-pane :label="$t('stockcard.optional')">
      <div v-show="$store.state.loginType">
        <el-table
          :data="concernData"
          size="mini"
          height="790px"
          :header-cell-style="{ fontSize: '13px',border: 'none', color: '#000000' }"
          :cell-style="{ border: 'none' }"
        >
          <el-table-column prop="symbolName" :label="$t('stock.name')">
            <template slot-scope="scope">
              <router-link
                :to="{
                  name: 'Stockdetailed',
                  query: { symbol: scope.row.symbol },
                }"
                class="stockLinkColor"
              >
                <span style="font-size: 13px">{{ scope.row.symbolName }}</span>
              </router-link>
            </template>
          </el-table-column>
          <el-table-column prop="trade" :label="$t('stock.price')" align="center">
            <template slot-scope="scope">
              <span style="color: var(--baseColor)">{{ scope.row.trade }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="changepercent" :label="$t('stock.qouteChange')" align="center">
            <template slot-scope="scope">
              <span
                class="green"
                v-if="scope.row.changepercent.substr(0, 1) === '-'"
                >{{ scope.row.changepercent }}%</span
              >
              <span class="red" v-else>{{ scope.row.changepercent }}%</span>
              <el-button
                size="mini"
                type="text"
                icon="el-icon-circle-close"
                @click="cancel_concern(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div
        class="center"
        v-show="!$store.state.loginType"
        style="height: 600px"
      >
        <router-link to="/login">
          <el-button type="primary" style="background-color: var(--baseColor);border-color:var(--baseColor)">{{$t('stock.pleaseSignIn')}}</el-button>
        </router-link>
      </div>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import eventBus from "../assets/js/eventBus";
import $ from "jquery";
export default {
  name: "stockcard",
  data() {
    return {
      // tableData: this.$store.state.stockVisited,
      concernData: [],
      gainsData: []
    }
  },
  computed: {
    tableData: function () {
      return this.$store.state.stockVisited
    },
  },
  methods: {
    getCardInfo() {
      let that = this;
      let stockVisited = that.tableData;
      that.chatTimer = setInterval(function () {
        that.getStockInfo(stockVisited)
      }, 1000);
    },
    getStockInfo(stockVisited) {
      let that = this;
      if (stockVisited.length !== 0) {
        let shortArr = [];
        for (let i = 0, len = stockVisited.length; i < len; i++) {
          shortArr.push(stockVisited[i].symbol);
        }
        that.getNewPrice(shortArr, stockVisited)
      }
    },
    getNewPrice(shortArr, dataArr) {
      let that = this;
      $.ajax({
        url: "https://qt.gtimg.cn/q=" + shortArr.toString(),
        type: "GET",
        dataType: "script",
        cache: true,
        success: function () {
          var i, elements;
          for (i = 0; i < shortArr.length; i++) {
            var elements = eval("v_" + shortArr[i]).split("~");
            dataArr[i].trade = elements[3];
            dataArr[i].changepercent = elements[32];
          }
          that.$store.commit('changeStocksVisited', dataArr);
        }
      });
    },
    getUserConcern() {
      let that = this;
      that
        .$http({
          url: "/app/Concern/concern",
          method: "POST",
          data: {
            page: 1,
            num: 20,
          }
        })
        .then(ret => {
          let resData = ret.data;
          if (ret.status == 200) {
            that.getUserConcernInfo(resData.data);
          }
        });
    },
    //获取自选股票详细数据
    getUserConcernInfo(Concern) {
      let that = this;

      if (Concern.length !== 0) {
        let symbol = '';
        for (let i = 0, len = Concern.length; i < len; i++) {
          symbol = symbol + 's_' + Concern[i].short_code + ',';
        }
        that
          .$http({
            url: "/app/Stock/stockdetail",
            method: "POST",
            data: {
              'symbol': symbol
            }
          })
          .then(ret => {
            let resData = ret.data;
            if (ret.status == 200) {
              let result = [];
              for (let i = 0, len = resData.data.length; i < len; i += 10) {
                result.push(resData.data.slice(i, i + 10));
              }
              result.pop();
              let temp = [];
              for (let i = 0, len = Concern.length; i < len; i++) {
                temp[i] = { symbol: Concern[i].short_code, code: Concern[i].code, symbolName: Concern[i].name, trade: result[i][3], changepercent: result[i][5] };
              }
              that.concernData = temp;
            }
          });
      } else {
        let temp = [];
        that.concernData = temp;
      }
    },
    getGainsData() {
      let that = this;
      that
        .$http({
          url: "/app/Stock/stock_change",
          method: "post",
          data: {
            'pageNo': 1,
            'asc': 0,
            'num': 15
          }
        }).then(ret => {
          let resData = ret.data;
          if (resData.status == 200) {
            that.gainsData = resData.data;
          } else {
            that.$alert(that.$t('stockUnactivity.pleaseTryLater'), that.$t('stockUnactivity.hint'), {
              confirmButtonText: that.$t('stockUnactivity.sure'),
              // callback: action => that.getTableData()
            })
          }
        });
    },
    cancel_concern(row) {
      let that = this;
      that
        .$http({
          url: "/app/Concern/cancel_concern",
          method: "POST",
          data: {
            'code': row.code
          }
        })
        .then(ret => {
          let resData = ret.data;
          if (ret.status == 200) {
            this.$message({
              message: that.$t(resData.msgId),
              type: 'success',
              onClose: function () {
                that.getUserConcern();
              }
            });
          } else {
            that.$message.error(that.$t(resData.msgId));
          }
        });
    }
  },
  created() {
    let that = this;
    eventBus.$on('concern', () => {
      that.getUserConcern();
    });
  },
  mounted: function () {
    let that = this;
    this.getCardInfo();
    if (that.$store.state.loginType) {
      this.getUserConcern();
    }
    this.getGainsData();
  },
  beforeDestroy() {
    clearTimeout(this.chatTimer);
  }
}
</script>

<style scoped>
.green {
  color: #008000;
}
.stockLinkColor {
  color: rgb(0, 0, 0);
}
.stockLinkColor :hover {
  color: #0100a0;
}

.content-section {
  background-color: #ffffff;
  padding: 10px;
  border-radius: 15px;
}
</style>
<style>
#stockCardtabs .el-tabs__active-bar {
  display: none;
  background-color: var(--baseColor);
}

#stockCardtabs .el-tabs__item.is-active {
  color: var(--baseColor);
}
#stockCardtabs .el-tabs__item:hover {
  color: var(--baseColor) !important;
}

#stockCardtabs .el-tabs__item.is-active:after {
  height: 6px;
  display: block;
  width: auto;
  background: var(--baseColor);
  content: "";
  border-radius: 5px;
  width: 45px;
  display: block;
  margin: 0 auto;
  top: -6px;
  position: relative;
}
</style>




// WEBPACK FOOTER //
// src/components/stockcard.vue